import Controller, { inject as controller } from '@ember/controller';

export default class PartsBuildHistoryProcessDataController extends Controller {
  @controller('parts/build-history') buildHistoryController;
}
